import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import PageBanner from 'components/banners/PageBanner';

function PressReleaseDetailsOne() {
  return (
    <div>
      <Helmet>
        <title>Press Releases - CAP60</title>
        <meta
          name="description"
          content="Press release is a tool made to announce something that is newsworthy in the most objective way possible. Read all press release for getting more information!."
        />
        <meta name="keywords" content="press release, cap60 press release" />
      </Helmet>
      <PageBanner title="The Community Action Partnership of Utah Selects CAP60 for Data Management Needs" />
      <Container>
        <div className="py-5">
          <Row>
            <Col md={3}>
              <p>
                <span className="font-weight-bold">DATE:</span>{' '}
                <span>June 15, 2017</span>
              </p>
            </Col>
            <Col md={3}>
              <p>
                <span className="font-weight-bold mr-2">CATEGORY:</span>
                <Badge variant="dark">Press Releases</Badge>
              </p>
            </Col>
          </Row>
          <h6 className="mt-4 mb-3 font-weight-bold">
            LOS ANGELES, CA – JUNE 15, 2017
          </h6>

          <p>
            The Community Action Partnership of Utah reviewed their data
            collecting and reporting process and decided to open up a request
            for proposals for case management software solutions. They reviewed
            numerous case management software solutions, which resulted in CAP60
            being awarded the contract to provide data management to eight of
            the nine CAP agencies in.
          </p>

          <p>
            “What set CAP60 apart from the other systems was their pricing and
            their robust system that was intuitive and user friendly.” Nissa
            Newton, Community Action Partnership of Utah Executive Director
          </p>
          <p>
            Once CAP60 was selected, the Community Action Partnership of Utah
            mapped, or linked, the programs and services provided by the eight
            Community Action Agencies to the National Performance Indicators set
            forth in ROMA Next Gen reporting. The mapping process went quickly
            and the agencies involved had a high level of agreement regarding
            the process. This also helped each agency to see how their programs
            related to other programs throughout the state.
          </p>

          <p>
            The Community Action Partnership of Utah has eight CAP agencies
            which provide services to more than 123,000 clients. With a
            comprehensive system in place, Utah agencies can record all
            community service efforts and referrals; volunteer information and
            transactions; and staff and board training events to assist with
            compliance and leveraging of fundin
          </p>
          <p>
            Company President, Hamid Kohan lauded the company’s recent success
            saying, “Our expedited technology development and experience with
            more than 235 agencies nationwide has resulted in our ability to
            make a significant impact in each agency’s performance and operation
            by increasing efficiency and productivity. As a result our client
            agencies are able to stay compliant with each funding source while
            providing the maximum level of service to their community.”
          </p>

          <h6>About CAP60:</h6>
          <p>
            CAP60 is a provider of comprehensive Agency and Program Management
            tools that are designed for use by Community Action Programs,
            Domestic Violence & Shelters, and other, as well as other Health and
            Human Services organizations. CAP60 provides services to Agencies in
            over 35 States nationwide, the U.S. Virgin Islands, and Canada.
            CAP60’s customized applications are designed to meet the data
            collection, tracking, and reporting needs of all aspects of an
            agency. For more information please visit www.cap60.com , email
            sales@cap60.com, or call <b>917-668-9174.</b>
          </p>
        </div>
      </Container>
    </div>
  );
}

export default PressReleaseDetailsOne;
